/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ChargeTransfer/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import * as fromHelpers from './helpers.js'
import AnotherPatient from './AnotherPatient/index'
import Content from './Content/index'
import Invoice from './Invoice/index'
import Popover from 'DesignSystem/Popover/index'
import PopoverContentHover from 'DesignSystem/Popover/PopoverContentHover/index'
import PopoverTrigger from 'DesignSystem/Popover/PopoverTrigger/index'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'
import TysiaIconExternalLink from 'DesignSystem/Svgs/TysiaIconExternalLink/index'
import TysiaTag from 'DesignSystem/TysiaTag/index'
import TysiaTagIcon from 'DesignSystem/TysiaTag/TysiaTagIcon/index'
import TysiaTagText from 'DesignSystem/TysiaTag/TysiaTagText/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import Tysiav2InfoFilled from 'DesignSystem/Svgs/Tysiav2InfoFilled/index'
import Tysiav2MinusIcon from 'DesignSystem/Svgs/Tysiav2MinusIcon/index'
import Tysiav2PaymentTransferIcon from 'DesignSystem/Svgs/Tysiav2PaymentTransferIcon/index'
import Tysiav2ReturnIcon from 'DesignSystem/Svgs/Tysiav2ReturnIcon/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function ChargeTransfer({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Ledger/New/Content/Transactions/Content/Expanded/EntryType/ChargeTransfer"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsRed200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.red.200'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsRed900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.red.900'
        })
let entryValueData = fromData.useDataFormat({ viewPath,
context: 'entry',
format: fromHelpers.getAmount,
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXxxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxxs'
        })
let dtColorsBlue900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.blue.900'
        })
let dtColorsBlue200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.blue.200'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let constantData = 'added on '
let entryCreatedAtValueData = fromData.useDataFormat({ viewPath,
context: 'entry',
path: 'created_at',
format: fromFormat.dateShortWithMonth,
})
let constantData1 = '.'
let aggregateData = fromAggregate.joinNoSpace(constantData, entryCreatedAtValueData, constantData1)
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
  return (<React.Fragment
>
<div
  data-testid="ChargeTransfer.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="ChargeTransfer.Vertical"
  data-view-path={viewPath}
 style={{'--btlr-1-1DLUSq': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btrr-2-1DLUSq': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bblr-3-1DLUSq': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bbrr-4-1DLUSq': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bc-5-1DLUSq': dtColorsRed200,'--mt-6-1DLUSq': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Vertical}`}
>
<Tysiav2MinusIcon
  viewPath={`${viewPath}/Tysiav2MinusIcon`}
 fill2={dtColorsRed900}
 width={6}
/>
</div>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginLeft={dtSpaceXxs}
 weight="medium"
 data="entry"
 format="helpers.js getAmount"
 text={entryValueData}
/>
<div
  data-testid="ChargeTransfer.Vertical:1"
  data-view-path={viewPath}
 style={{'--ml-7-1DLUSq': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--g-8-1DLUSq': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Vertical1}`}
>
<div
  data-testid="ChargeTransfer.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<TysiaTag
  viewPath={`${viewPath}/TysiaTag`}
 type="blue"
 style="filled"
 marginTop={dtSpaceXxxs}
>
{childProps => (
<React.Fragment>
<TysiaTagIcon
{...childProps}
  viewPath={`${viewPath}/TysiaTagIcon`}
>
{childProps => (
<Tysiav2PaymentTransferIcon
{...childProps}
  viewPath={`${viewPath}/Tysiav2PaymentTransferIcon`}
 fill={dtColorsBlue900}
 stroke={dtColorsBlue200}
 width={12}
 height={12}
/>
)}
</TysiaTagIcon>
<TysiaTagText
{...childProps}
  viewPath={`${viewPath}/TysiaTagText`}
 text="Transfer Debt"
/>
</React.Fragment>
)}
</TysiaTag>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 size="small"
 type="ghost"
 marginLeft={dtSpaceXxxs}
 marginTop={3}
 height="auto"
 paddingLeft={0}
 paddingRight={0}
>
{childProps => (
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<TysiaIconExternalLink
{...childProps}
  viewPath={`${viewPath}/TysiaIconExternalLink`}
 fill={dtColorsWhite}
 width={13}
 height={13}
/>
)}
</TysiaButtonIcon>
)}
</TysiaButton>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginLeft={dtSpaceXxs}
 data="'added on '"
 data="entry.created_at"
 format="/Data/format.js dateShortWithMonth"
 data="'.'"
 aggregate="/Data/aggregate.js joinNoSpace"
 text={aggregateData}
/>
<Popover
  viewPath={`${viewPath}/Popover`}
 showOnClick={false}
 showOnHover={true}
 placement="bottom"
 offsetMainAxis={dtSpaceXs}
>
{childProps => (
<React.Fragment>
<PopoverTrigger
{...childProps}
  viewPath={`${viewPath}/PopoverTrigger`}
>
{childProps => (
<TysiaButton
{...childProps}
  viewPath={`${viewPath}/TysiaButton`}
 size="small"
 type="ghost"
 marginLeft={dtSpaceXxxs}
 marginTop={3}
 height="auto"
 paddingLeft={0}
 paddingRight={0}
>
{childProps => (
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<Tysiav2InfoFilled
{...childProps}
  viewPath={`${viewPath}/Tysiav2InfoFilled`}
 width={13}
 height={13}
 fill2={dtColorsNeutral400}
/>
)}
</TysiaButtonIcon>
)}
</TysiaButton>
)}
</PopoverTrigger>
<PopoverContentHover
{...childProps}
  viewPath={`${viewPath}/PopoverContentHover`}
>
{childProps => (
<Content
{...childProps}
  viewPath={`${viewPath}/Content`}
/>
)}
</PopoverContentHover>
</React.Fragment>
)}
</Popover>
</div>
<div
  data-testid="ChargeTransfer.Horizontal:2"
  data-view-path={viewPath}
 style={{'--g-8-1DLUSq': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal2}`}
>
<Tysiav2ReturnIcon
  viewPath={`${viewPath}/Tysiav2ReturnIcon`}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 color={dtColorsNeutral600}
 text="Transferred to"
/>
<AnotherPatient
  viewPath={`${viewPath}/AnotherPatient`}
/>
<Invoice
  viewPath={`${viewPath}/Invoice`}
/>
</div>
</div>
</div>
{children}
</React.Fragment>)
}